// Formats HollowScript through the real formatter (Cascade's `format.ts` is
// a direct pattern - ported here rather than imported since Cascade is a
// separate app/package with no shared-code path to this repo), so the
// editor's "Format Document" action and any future `hollowscript format`
// CLI can never disagree about what canonical HollowScript looks like.

import { format } from '@hollow/script';

export interface HollowScriptFormatResult {
  readonly formatted?: string;
  readonly error?: string;
}

/** Formats `source`, or explains why it could not be (a parse error - the
 * formatter never guesses at malformed input, spec.md's own rule). Never
 * throws. */
export function formatHollowScriptSource(source: string): HollowScriptFormatResult {
  const result = format(source);
  if (result.formatted !== undefined) return { formatted: result.formatted };
  const message = result.diagnostics.map((d) => d.message).join('; ') || 'Could not format: the source has a parse error.';
  return { error: message };
}
